module.exports = __webpack_public_path__ + "static/faisal-5a7bca8b2314610b0734a354e1bd6047.png";